module.exports = __webpack_public_path__ + "img/00048.b46a951b.webp";